import { gql } from '@apollo/client';
// import { actionFragment } from './Fragments';

export const DAILY_GOALS_AND_BLOCKERS = gql`
  query dailyGoalsAndBlockers($where: DailyGoalWhereInput!, $sortBy: SortByInput, $sortOn: SortOnDailyGoalsAndBlockersInput, $skip: Int, $limit: Int) {
    dailyGoalsAndBlockers(where: $where, sortBy: $sortBy, sortOn: $sortOn, skip: $skip, limit: $limit)
  }
`;
